import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import { useBlog } from "../../context/BlogContext";
import "./BlogContentPage.css";

const BlogContentPage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { currentPost, loading, error, fetchPost, clearCurrentPost } = useBlog();

  useEffect(() => {
    if (slug) fetchPost(slug);
    return () => clearCurrentPost();
  }, [slug, fetchPost, clearCurrentPost]);

  useEffect(() => {
    if (currentPost) {
      document.title = `${currentPost.title} | Brandly Blog`;
    }
  }, [currentPost]);

  if (loading) {
    return (
      <div className="blog-content-page">
        <Navbar />
        <div className="blog-loading">
          <div className="loading-spinner">Loading blog post...</div>
        </div>
        <Footer />
      </div>
    );
  }

  if (error) {
    return (
      <div className="blog-content-page">
        <Navbar />
        <div className="blog-error">
          <h2>Error loading blog post</h2>
          <p>{error}</p>
          <button onClick={() => navigate("/blogs")} className="back-button">
            Back to Blogs
          </button>
        </div>
        <Footer />
      </div>
    );
  }

  if (!currentPost) {
    return (
      <div className="blog-content-page">
        <Navbar />
        <div className="blog-error">
          <h2>Blog post not found</h2>
          <p>The blog post you're looking for doesn't exist.</p>
          <button onClick={() => navigate("/blogs")} className="back-button">
            Back to Blogs
          </button>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="blog-content-page">
      <Navbar />
      <div className="blog-content-wrapper">
        <div className="blog-content-card">

          {/* Back Navigation */}
          <div className="blog-back-nav">
            <button onClick={() => navigate("/blogs")} className="back-button">
              ← Back to Blogs
            </button>
          </div>

          

          {/* Blog Header */}
          <div className="blog-header">
            <h1 className="blog-title">{currentPost.title}</h1>

            {/* AUTHOR + DATE + READ TIME (one line) */}
            <div className="blog-meta-row">
              {currentPost.author?.profilePicture && (
                <img
                  src={currentPost.author.profilePicture}
                  alt={currentPost.author.name}
                  className="meta-avatar"
                />
              )}

              <span className="meta-author">{currentPost.author?.name}</span>

              <span className="meta-separator">•</span>

              <span className="meta-date">
                {new Date(currentPost.publishedAt).toLocaleDateString(
                  "en-US",
                  {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  }
                )}
              </span>

              <span className="meta-separator">•</span>

              <span className="meta-readtime">
                {currentPost.readTimeInMinutes || 5} min read
              </span>
            </div>

            {currentPost.subtitle && (
              <h2 className="blog-subtitle">{currentPost.subtitle}</h2>
            )}

            <p className="blog-summary">{currentPost.brief}</p>
          </div>

          {/* Cover Image */}
          {currentPost.coverImage && (
            <img
              src={currentPost.coverImage.url}
              alt={currentPost.title}
              className="blog-image"
            />
          )}

          {/* Blog Content */}
          {currentPost.content && (
            <div
              className="blog-body"
              dangerouslySetInnerHTML={{ __html: currentPost.content.html }}
            />
          )}

          {/* Tags */}
          {currentPost.tags && currentPost.tags.length > 0 && (
            <div className="blog-tags">
              <h3>Tags:</h3>
              <div className="tags-list">
                {currentPost.tags.map((tag, index) => (
                  <span key={index} className="tag">
                    {tag.name}
                  </span>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>  
      <Footer />
    </div>
  );
};

export default BlogContentPage;
